import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";

export default function V2ProductCard({ product, testIdPrefix = "v2-product" }) {
  const { add } = useCart();
  const gallery = product.gallery || [product.image];
  const hoverImage = gallery[1] || product.image;
  const discount = product.mrp && product.mrp > product.price_from ? Math.round((1 - product.price_from / product.mrp) * 100) : 0;

  const quickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const enabled = (product.variants || []).filter((v) => v.enabled);
    const variant = enabled.find((v) => v.stock > 0) || null;
    if (enabled.length && !variant) { toast.error(`${product.name} is sold out`); return; }
    add(product, 1, variant);
    toast.success(`${product.name}${variant ? ` (${variant.size} ft)` : ""} added to basket`);
  };

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`${testIdPrefix}-card-${product.id}`}
      className="group block"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#f2ede2]">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover absolute inset-0 transition-opacity duration-500 group-hover:opacity-0"
        />
        <img
          src={hoverImage}
          alt=""
          loading="lazy"
          className="w-full h-full object-cover absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        />
        {discount > 0 && (
          <div className="absolute top-4 left-4 v2-badge-terra">{discount}% off</div>
        )}
        <button
          onClick={quickAdd}
          data-testid={`${testIdPrefix}-quick-add-${product.id}`}
          className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 bg-[#1a1a1a] text-[#fbf9f5] px-5 py-3 text-[11px] tracking-[0.22em] uppercase inline-flex items-center justify-center gap-2 hover:bg-[#b85742]"
        >
          <ShoppingBag size={12} /> Quick Add
        </button>
      </div>
      <div className="mt-4">
        <div className="font-serif-warm text-lg text-[#1a1a1a] leading-tight">{product.name}</div>
        <div className="mt-1 flex items-baseline gap-2">
          <span className="text-[14px] text-[#1a1a1a] font-medium">₹{product.price_from.toLocaleString("en-IN")}</span>
          {product.mrp && product.mrp > product.price_from && (
            <span className="text-[12px] text-[#7a7466] line-through">₹{product.mrp.toLocaleString("en-IN")}</span>
          )}
        </div>
        {product.dimensions && (
          <div className="mt-1 text-[11px] uppercase tracking-[0.18em] text-[#7a7466]">
            {product.dimensions.split("·")[0].trim()} · {product.material?.replace("_", " ")}
          </div>
        )}
      </div>
    </Link>
  );
}
